import signalr from 'BASE/common/signalrAdapter';
import websiteInfoUtil from 'BASE/common/util/util.websiteInfo';
import userInfo_component from 'BASE/components/userInfo.component'; //權限等狀態初始化須使用
import BetAwardNotifyComponent from 'XY/components/notification/betAwardNotify.component';
import ToastNotificationComponent from 'BASE/components/notification/toastNotification.component';
import { offAllInput } from 'BASE/plugins/autoCompletePlugin';
import StreamingNotificationComponent from 'XY/views/Notification/StreamingNotification.vue';
import { actionTypes } from 'BASE/store/types';

export default {
    mixins: [websiteInfoUtil, userInfo_component],
    components: {
        BetAwardNotifyComponent,
        ToastNotificationComponent,
        StreamingNotificationComponent,
    },
    data: function () {
        return {
            appClass: '',
            notificationCount: 1,

            // 覆寫父類別的資料撈取配置，自訂XY商戶需要的資料
            dataConfig: {
                parallel: [
                    actionTypes.USER_INFO_PRIVILEGES,
                    actionTypes.USER_INFO_PRIVILEGES_BONUS,
                    actionTypes.LOTTOGAME_DATA,
                    actionTypes.USER_INFO_GET_BASE_DATA,
                    actionTypes.USER_INFO_ALERTS,
                    actionTypes.VIP_INFO,
                    actionTypes.USER_INFO_DEMO_LINK,
                    actionTypes.USER_INFO_TELEGRAM_BOT,
                ]
            }
        }
    },
    computed:{
        isLogin() {
            return this.$store.state.userinfo.isLogin;
        },
        skinClass(){
            if(!this.CanUseSkin){
                return '';
            }
            return this.$store.state.userinfo.skinClass;
        },

        CanUseSkin(){
            let val = this.$route.name;
            let _skinHandle = ['Bet','ComboBet'];

            if( val != null && _skinHandle.find((item) => val==item )){
                return true;
            }
            return false;
        },

    },
    watch: {
        isLogin: {
            immediate: true,
            handler(v) {
                if (v) {
                    signalr.init();
                }
            }
        },
    },
    updated(){
        this.$nextTick(function () {
            // 關閉當下所有input的自動填入，減少大部分瀏覽器自動填入狀況，剩下部分手動使用autoCompletePlugin排除
            offAllInput(this.$el);
        });        
    },
};